export default function convertToDms(
  coordinate?: string,
  isLatitude?: boolean
) {
  if (coordinate === undefined) {
    return
  }
  const num = Number(coordinate)
  const absolute = Math.abs(num)
  const degrees = Math.floor(absolute)
  const minutesNotTruncated = (absolute - degrees) * 60
  const minutes = Math.floor(minutesNotTruncated)
  const seconds = Math.floor((minutesNotTruncated - minutes) * 60 * 10) / 10

  let direction
  if (isLatitude) {
    direction = num >= 0 ? 'N' : 'S'
  } else {
    direction = num >= 0 ? 'E' : 'W'
  }

  return `${degrees}°${minutes}'${seconds}"${direction}`
}
